import { useGSAP } from "@gsap/react";
import { type RefObject } from "react";
import { gsap } from "../lib/gsap";

type RevealOptions = {
  targets: string;
  stagger?: number;
  duration?: number;
  y?: number;
  x?: number;
  delay?: number;
  start?: string;
  scrollTrigger?: boolean;
};

export function useScrollReveal(
  containerRef: RefObject<HTMLElement | null>,
  options: RevealOptions
): void {
  const {
    targets,
    stagger = 0.12,
    duration = 0.7,
    y = 40,
    x = 0,
    delay = 0,
    start = "top 85%",
    scrollTrigger: useScrollTrigger = true,
  } = options;

  useGSAP(
    () => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      const container = containerRef.current;
      if (!container) return;

      const elements = container.querySelectorAll<HTMLElement>(targets);
      if (!elements.length) return;

      const toVars: gsap.TweenVars = {
        opacity: 1,
        y: 0,
        x: 0,
        duration,
        delay,
        ease: "power2.out",
        stagger,
      };

      if (useScrollTrigger) {
        toVars.scrollTrigger = {
          trigger: container,
          start,
          once: true,
        };
      }

      gsap.fromTo(elements, { opacity: 0, y, x }, toVars);
    },
    { scope: containerRef }
  );
}
